import React, { useState, useEffect } from 'react';

const API = 'https://api.pixventa.com';

function formatPesos(num) {
  return '$' + Math.round(num).toLocaleString('es-MX');
}

function diasEntre(fecha) {
  const hoy = new Date(); hoy.setHours(0,0,0,0);
  const fin = new Date(fecha); fin.setHours(0,0,0,0);
  return Math.round((fin - hoy) / (1000*60*60*24));
}

function formatFecha(str) {
  if (!str) return '—';
  return new Date(str).toLocaleDateString('es-MX', { day:'2-digit', month:'short', year:'numeric' });
}

const ESTADO_BADGE = {
  activo:    { bg:'#E1F5EE', color:'#085041', label:'Activo' },
  bloqueado: { bg:'#FCEBEB', color:'#501313', label:'Bloqueado' },
  prueba:    { bg:'#FFF3E0', color:'#E65100', label:'Prueba' },
};

const S = {
  topbar:    { display:'flex', justifyContent:'space-between', alignItems:'center', marginBottom:20 },
  h1:        { fontSize:20, fontWeight:700, color:'#0D1F1A' },
  selMes:    { padding:'6px 12px', borderRadius:8, border:'1px solid #E4EDE8', background:'white', fontSize:12, color:'#0D1F1A', cursor:'pointer', fontFamily:'inherit' },
  alert:     { borderRadius:12, padding:'10px 16px', fontSize:12, marginBottom:8, display:'flex', alignItems:'center', gap:8 },
  metrics:   { display:'grid', gridTemplateColumns:'repeat(4,1fr)', gap:12, marginBottom:20 },
  metric:    { background:'white', borderRadius:12, padding:'14px', border:'1px solid #E4EDE8' },
  mLbl:      { fontSize:11, color:'#7A8F89', marginBottom:6 },
  mVal:      { fontSize:22, fontWeight:800, color:'#0D1F1A' },
  mSub:      { fontSize:10, color:'#7A8F89', marginTop:3 },
  grid2:     { display:'grid', gridTemplateColumns:'1fr 1fr', gap:16, marginBottom:16 },
  card:      { background:'white', borderRadius:12, border:'1px solid #E4EDE8' },
  cardHdr:   { padding:'12px 16px', borderBottom:'1px solid #E4EDE8', display:'flex', justifyContent:'space-between', alignItems:'center' },
  cardTitle: { fontSize:13, fontWeight:700, color:'#0D1F1A' },
  cardBody:  { padding:16 },
  barRow:    { display:'flex', alignItems:'center', gap:10, marginBottom:10 },
  barLabel:  { fontSize:12, color:'#7A8F89', width:140, overflow:'hidden', textOverflow:'ellipsis', whiteSpace:'nowrap' },
  barTrack:  { flex:1, height:10, background:'#F0F4F0', borderRadius:5, overflow:'hidden' },
  barFill:   { height:'100%', borderRadius:5, background:'#075E54' },
  barAmt:    { fontSize:12, fontWeight:700, color:'#0D1F1A', minWidth:58, textAlign:'right' },
  statRow:   { display:'flex', justifyContent:'space-between', padding:'7px 0', borderBottom:'1px solid #E4EDE8', fontSize:12 },
  table:     { width:'100%', borderCollapse:'collapse', fontSize:12 },
  th:        { padding:'9px 12px', textAlign:'left', fontSize:11, fontWeight:700, color:'#7A8F89', borderBottom:'1px solid #E4EDE8', background:'#F0F4F0' },
  td:        { padding:'10px 12px', borderBottom:'1px solid #E4EDE8', color:'#0D1F1A' },
  badge:     { display:'inline-block', padding:'2px 8px', borderRadius:20, fontSize:11, fontWeight:600 },
  subdom:    { fontSize:11, color:'#7A8F89' },
  subdomSpan:{ color:'#075E54', fontWeight:600 },
  btn:       { fontSize:11, padding:'4px 8px', borderRadius:8, border:'1px solid #E4EDE8', background:'none', color:'#7A8F89', cursor:'pointer', marginRight:4, fontFamily:'inherit' },
  btnOk:     { color:'#085041', borderColor:'#5DCAA5' },
  btnRojo:   { color:'#A32D2D', borderColor:'#F09595' },
  cargando:  { textAlign:'center', padding:40, color:'#7A8F89', fontSize:13 },
};

export default function Dashboard({ onNavegar }) {
  const [tiendas,      setTiendas]      = useState([]);
  const [planes,       setPlanes]       = useState([]);
  const [suscripciones,setSuscripciones] = useState([]);
  const [cargando,     setCargando]     = useState(true);
  const [filtroEstado, setFiltroEstado] = useState('todos');

  useEffect(() => { cargarDatos(); }, []);

  async function cargarDatos() {
    try {
      setCargando(true);
      const [rTiendas, rPlanes, rSus] = await Promise.all([
        fetch(`${API}/admin/tiendas`).then(r => r.json()),
        fetch(`${API}/admin/planes`).then(r => r.json()),
        fetch(`${API}/admin/suscripciones`).then(r => r.json()),
      ]);
      setTiendas(rTiendas);
      setPlanes(rPlanes);
      setSuscripciones(rSus);
    } catch (err) {
      console.error('Error cargando dashboard:', err);
    } finally {
      setCargando(false);
    }
  }

  // Enriquecer tiendas con datos de suscripción y plan
  const tiendasEnriquecidas = tiendas.map(t => {
    const plan = planes.find(p => p.id === t.plan_id);
    const susActiva = suscripciones.find(s => s.tienda_id === t.id && s.estado === 'activo');
    const comision = susActiva ? (parseFloat(susActiva.monto) * parseFloat(plan?.comision || 0) / 100) : 0;
    const dias = susActiva ? diasEntre(susActiva.fecha_fin) : null;
    let proximoPago = '—';
    if (t.estado === 'prueba') proximoPago = 'En prueba';
    else if (dias === null) proximoPago = 'Sin suscripción';
    else if (dias < 0) proximoPago = 'Vencido';
    else proximoPago = formatFecha(susActiva.fecha_fin);

    return {
      ...t,
      plan_nombre: plan?.nombre || 'Sin plan',
      plan_comision: parseFloat(plan?.comision || 0),
      plan_precio: parseFloat(plan?.precio || 0),
      monto: susActiva ? parseFloat(susActiva.monto) : 0,
      comision,
      proximoPago,
      diasVencimiento: dias,
    };
  });

  // Métricas
  const tiendaActivas  = tiendasEnriquecidas.filter(t => t.estado === 'activo');
  const mrr            = tiendaActivas.reduce((a, t) => a + t.monto, 0);
  const totalComision  = tiendasEnriquecidas.reduce((a, t) => a + t.comision, 0);
  const maxComision    = Math.max(...tiendasEnriquecidas.map(t => t.comision), 1);

  // Alertas
  const vencidas = tiendasEnriquecidas.filter(t => t.proximoPago === 'Vencido');
  const proximas = tiendasEnriquecidas.filter(t => t.diasVencimiento !== null && t.diasVencimiento >= 0 && t.diasVencimiento <= 7);

  // Distribución de planes
  const distPlanes = planes.map(p => ({
    ...p,
    count: tiendasEnriquecidas.filter(t => t.plan_id === p.id).length,
  }));

  const filtradas = filtroEstado === 'todos' ? tiendasEnriquecidas : tiendasEnriquecidas.filter(t => t.estado === filtroEstado);

  if (cargando) return <div style={S.cargando}>Cargando dashboard...</div>;

  return (
    <div>
      <div style={S.topbar}>
        <h1 style={S.h1}>Dashboard</h1>
        <button style={{ ...S.selMes, cursor:'pointer' }} onClick={cargarDatos}>↻ Actualizar</button>
      </div>

      {/* Alertas */}
      {(vencidas.length > 0 || proximas.length > 0) && (
        <div style={{ marginBottom:20, display:'flex', flexDirection:'column', gap:8 }}>
          {vencidas.length > 0 && (
            <div style={{ ...S.alert, background:'#FCEBEB', border:'1px solid #F09595', color:'#501313' }}>
              🔴 <strong>{vencidas.length} pago(s) vencido(s)</strong> —
              {vencidas.map(t => <strong key={t.id} style={{ color:'#A32D2D' }}> {t.subdominio}</strong>)}.
              Acceso bloqueado automáticamente.
            </div>
          )}
          {proximas.length > 0 && (
            <div style={{ ...S.alert, background:'#FFF3E0', border:'1px solid #ffcc80', color:'#633806' }}>
              🟡 <strong>{proximas.length} suscripción(es)</strong> próximas a vencer —
              {proximas.map(t => <strong key={t.id} style={{ color:'#e65100' }}> {t.subdominio}</strong>)}.
            </div>
          )}
        </div>
      )}

      {/* Métricas */}
      <div style={S.metrics}>
        <div style={S.metric}>
          <div style={S.mLbl}>Tiendas activas</div>
          <div style={S.mVal}>{tiendaActivas.length}</div>
          <div style={S.mSub}>De {tiendas.length} registradas</div>
        </div>
        <div style={S.metric}>
          <div style={S.mLbl}>MRR suscripciones</div>
          <div style={S.mVal}>{formatPesos(mrr)}</div>
          <div style={S.mSub}>Ingresos recurrentes</div>
        </div>
        <div style={S.metric}>
          <div style={S.mLbl}>Comisiones del mes</div>
          <div style={{ ...S.mVal, color:'#075E54' }}>{formatPesos(totalComision)}</div>
          <div style={S.mSub}>Sobre ventas de tiendas</div>
        </div>
        <div style={S.metric}>
          <div style={S.mLbl}>Ingresos totales</div>
          <div style={S.mVal}>{formatPesos(mrr + totalComision)}</div>
          <div style={S.mSub}>Suscrip. + comisiones</div>
        </div>
      </div>

      <div style={S.grid2}>
        {/* Comisiones por tienda */}
        <div style={S.card}>
          <div style={S.cardHdr}>
            <div style={S.cardTitle}>Comisiones por tienda</div>
            <span style={{ fontSize:13, color:'#075E54', fontWeight:700 }}>{formatPesos(totalComision)}</span>
          </div>
          <div style={S.cardBody}>
            {tiendasEnriquecidas.filter(t => t.comision > 0).length === 0 && (
              <div style={{ fontSize:12, color:'#7A8F89' }}>Sin comisiones registradas aún</div>
            )}
            {tiendasEnriquecidas.filter(t => t.comision > 0).map(t => (
              <div key={t.id} style={S.barRow}>
                <div style={S.barLabel}>{t.nombre}</div>
                <div style={S.barTrack}><div style={{ ...S.barFill, width:`${(t.comision/maxComision)*100}%` }} /></div>
                <div style={S.barAmt}>{formatPesos(t.comision)}</div>
              </div>
            ))}
            <div style={{ fontSize:11, color:'#7A8F89', marginTop:8, paddingTop:8, borderTop:'1px solid #E4EDE8' }}>
              {tiendasEnriquecidas.filter(t => t.plan_comision === 0).length} tiendas en plan Gratis — sin comisión
            </div>
          </div>
        </div>

        {/* Distribución de planes */}
        <div style={S.card}>
          <div style={S.cardHdr}><div style={S.cardTitle}>Distribución de planes</div></div>
          <div style={S.cardBody}>
            {distPlanes.map(p => (
              <div key={p.id} style={S.statRow}>
                <span style={{ color:'#7A8F89' }}>Plan {p.nombre} {p.precio > 0 ? `$${Number(p.precio).toLocaleString('es-MX')}` : ''}</span>
                <span>{p.count} tienda{p.count !== 1 ? 's' : ''}</span>
              </div>
            ))}
            <div style={S.statRow}>
              <span style={{ color:'#7A8F89' }}>Pagos vencidos</span>
              <span style={{ color:'#A32D2D', fontWeight:700 }}>{vencidas.length} tiendas</span>
            </div>
            <div style={{ ...S.statRow, borderBottom:'none', paddingTop:10, marginTop:4, borderTop:'1px solid #E4EDE8' }}>
              <span style={{ fontWeight:700, color:'#0D1F1A' }}>MRR estimado</span>
              <span style={{ color:'#075E54', fontWeight:700 }}>{formatPesos(mrr)}</span>
            </div>
          </div>
        </div>
      </div>

      {/* Tabla de tiendas */}
      <div style={S.card}>
        <div style={S.cardHdr}>
          <div style={S.cardTitle}>Todas las tiendas</div>
          <select style={S.selMes} value={filtroEstado} onChange={e => setFiltroEstado(e.target.value)}>
            <option value="todos">Todos los estados</option>
            <option value="activo">Activos</option>
            <option value="bloqueado">Bloqueados</option>
            <option value="prueba">En prueba</option>
          </select>
        </div>
        <table style={S.table}>
          <thead>
            <tr>
              <th style={S.th}>Tienda</th>
              <th style={S.th}>Plan</th>
              <th style={S.th}>Suscripción</th>
              <th style={S.th}>Próximo pago</th>
              <th style={S.th}>Estado</th>
              <th style={S.th}>Acciones</th>
            </tr>
          </thead>
          <tbody>
            {filtradas.length === 0 && (
              <tr><td colSpan={6} style={{ ...S.td, textAlign:'center', color:'#7A8F89', padding:32 }}>Sin tiendas registradas</td></tr>
            )}
            {filtradas.map(t => {
              const estado = ESTADO_BADGE[t.estado] || ESTADO_BADGE.prueba;
              return (
                <tr key={t.id}>
                  <td style={S.td}>
                    <div style={{ fontWeight:700 }}>{t.nombre}</div>
                    <div style={S.subdom}><span style={S.subdomSpan}>{t.subdominio}</span>.pixventa.com</div>
                  </td>
                  <td style={S.td}>
                    <span style={{ ...S.badge, background:'#F0F4F0', color:'#7A8F89' }}>
                      {t.plan_nombre} {t.plan_comision > 0 ? `${t.plan_comision}%` : ''}
                    </span>
                  </td>
                  <td style={{ ...S.td, color:'#075E54', fontWeight:700 }}>
                    {t.monto > 0 ? formatPesos(t.monto) : '—'}
                  </td>
                  <td style={{ ...S.td, color: t.proximoPago==='Vencido'?'#A32D2D': t.diasVencimiento !== null && t.diasVencimiento <= 7 ? '#e65100' : '#0D1F1A' }}>
                    {t.proximoPago}
                  </td>
                  <td style={S.td}><span style={{ ...S.badge, background:estado.bg, color:estado.color }}>{estado.label}</span></td>
                  <td style={S.td}>
                    <button style={{ ...S.btn }} onClick={() => onNavegar('negocios')}>Ver</button>
                  </td>
                </tr>
              );
            })}
          </tbody>
        </table>
      </div>
    </div>
  );
}